/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyGroupListQuery
 */
export interface AgencyGroupListQuery {
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupListQuery
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyGroupListQuery
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof AgencyGroupListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof AgencyGroupListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgencyGroupListQuery
     */
    limit?: number | null;
}

export function AgencyGroupListQueryFromJSON(json: any): AgencyGroupListQuery {
    return AgencyGroupListQueryFromJSONTyped(json, false);
}

export function AgencyGroupListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyGroupListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function AgencyGroupListQueryToJSON(value?: AgencyGroupListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'showNonEffective': value.showNonEffective,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'offset': value.offset,
        'limit': value.limit,
    };
}


